import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { TableActionsCellSpace } from '@framework/ui/components/table/TableActionsCellSpace.tsx';
import { SubmissionLogic } from '../../SubmissionLogic.ts';
import { SummarySignatureModalButton } from '../SummarySignatureModalButton.tsx';
import { DownloadModuleButton } from './DownloadModuleButton.tsx';
import { GoToModuleButton } from './GoToModuleButton.tsx';
import { ModuleJsonModalButton } from './ModuleJsonModalButton.tsx';
import { type IModuleTableRow } from './modulesColumns.tsx';

interface IModuleActionsCellProps {
  submissionId: string;
  record: IModuleTableRow;
  submission?: RichiestaDTO;
}

/**
 * Cella azioni per la tabella moduli nel riepilogo esteso.
 * Mostra fino a 5 pulsanti: Scarica, Visualizza, Verifica firma,
 * Visualizza JSON e Vai al modulo.
 */
export function ModuleActionsCell(props: IModuleActionsCellProps) {
  const { submissionId, record, submission } = props;

  const isDisabled =
    SubmissionLogic.isSubmissionNew(submission) ||
    !record.module.statoValidazione?.visitato;

  const signedModuleFileId =
    record.module.idFileFirmato ?? record.module.idFile;

  return (
    <TableActionsCellSpace>
      <DownloadModuleButton
        submissionId={submissionId}
        submissionModuleId={record.module.id!}
        disabled={isDisabled}
        isOmissis={record.isOmissis}
      />
      <DownloadModuleButton
        submissionId={submissionId}
        submissionModuleId={record.module.id!}
        disabled={isDisabled}
        isOmissis={record.isOmissis}
        viewInline
        queryKeySuffix="inline-view"
      />
      {!record.isOmissis && record.module.firmato && signedModuleFileId && (
        <SummarySignatureModalButton
          size="small"
          signedFile={{
            uid: signedModuleFileId,
            name: record.module.nomeFileInterno ?? record.title,
            status: 'done',
          }}
          signatures={record.module.riepilogoDettagliFirma ?? undefined}
        />
      )}
      {!record.isOmissis && (
        <ModuleJsonModalButton
          size="small"
          submissionId={submissionId}
          moduleId={record.module.id!}
          procedureId={submission?.idIstanzaProcedimento ?? undefined}
        />
      )}
      {!record.isOmissis && (
        <GoToModuleButton
          submissionId={submissionId}
          module={record.module}
          submission={submission}
        />
      )}
    </TableActionsCellSpace>
  );
}
